import BaseModel from "./base/baseModel";
import Ufs from "./enum/ufs";

export default class RepresentanteModel extends BaseModel {
    constructor() {
        super();
    }

    id?: number = null;
    nome: string = null;
    observacao: string = null;
    cpf: string = null;
    cep: string = null;
    estadoId?: Ufs = null;
    cidadeId?: number = null;
    cidade: string = null;
    endereco: string = null;
    bairro: string = null;
    numero: string = null;
    complemento: string = null;
    telefone: string = null;
    celular: string = null;
    email: string = null;
}
